import { RouterProvider } from 'react-router-dom';
// Import Swiper CSS
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import './App.css';
import { routes } from './Routes/Router';
import './assets/css/style.css';
import './assets/css/loading.css';
import './assets/css/project-gallery.css';
import ErrorBoundary from './components/ErrorBoundary';
import { GeneralDataProvider } from './data/GeneralDataContext';
import { ProjectDataProvider } from './data/ProjectDataContext';
import { TeamDataProvider } from './data/TeamDataContext';
import { FunFactsDataProvider } from './data/FunFactsDataContext';

function App() {
  return (
    <ErrorBoundary showDetails={process.env.NODE_ENV === 'development'}>
      <GeneralDataProvider>
        <ProjectDataProvider>
          <TeamDataProvider>
            <FunFactsDataProvider>
              <div>
                <RouterProvider router={routes} />
              </div>
            </FunFactsDataProvider>
          </TeamDataProvider>
        </ProjectDataProvider>
      </GeneralDataProvider>
    </ErrorBoundary>
  );
}

export default App;
